import React from "react";

const RoutineView = ({ routineModal }) => {
  // Function to determine if the source is a PDF
  const isPDF = (src) => {
    return src && src.toLowerCase().endsWith(".pdf");
  };

  return (
    <div style={{ textAlign: "center" }}>
      {routineModal ? (
        isPDF(routineModal) ? (
          // Render PDF preview
          <object
            data={routineModal}
            type="application/pdf"
            width="100%"
            height="500px"
          >
            <p>
              Your browser does not support PDFs.{" "}
              <a href={routineModal}>Download the PDF</a>.
            </p>
          </object>
        ) : (
          // Render image
          <img
            src={routineModal}
            alt="Routine"
            style={{
              maxWidth: "100%",
              maxHeight: "500px",
              objectFit: "contain",
              margin: "0 auto",
            }}
          />
        )
      ) : (
        // Fallback message
        <p style={{ fontWeight: "bold" }}>No Image Available</p>
      )}
    </div>
  );
};

export default RoutineView;
